"use client";

import React from "react";

import { List, ListItem, Typography } from "@mui/material";
import Box from "@mui/material/Box";

import { CountrySelectorChildrenProps } from "~/bff/components/CountrySelectorChildren";
import { FooterSocialLinksItemProps } from "~/bff/components/FooterSocialLinksItem";
import { CountrySelector } from "~/components/country-selector/component";
import { CountryCode } from "~/helpers/country/types";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { LinkItem } from "../link-item/component";

import { GROUPED_LINKS_COLUMN_CLASSES } from "./constants";
import { GroupedLinksColumnContainer } from "./styled";

interface GroupedLinksColumnProps {
  headline?: string;
  setSelectedCountry: (c?: CountryCode) => void;
  showCountrySelector: boolean;
  countries?: (CountrySelectorChildrenProps | undefined)[];
  selectedCountry?: CountryCode;
  selectedLanguage?: string;
  links?: (FooterSocialLinksItemProps | undefined)[];
  title?: string;
  description?: string;
  shouldOpenAllLinksInNewTab?: boolean;
}

export const GroupedLinksColumn: React.FC<GroupedLinksColumnProps> = ({
  headline,
  links,
  selectedCountry,
  setSelectedCountry,
  showCountrySelector,
  countries,
  title,
  description,
  shouldOpenAllLinksInNewTab,
  selectedLanguage,
}) => {
  const sectionId = headline?.replace(" ", "-").toLowerCase();
  const titleId = `footer-title-${sectionId}`;

  return (
    <GroupedLinksColumnContainer
      component="nav"
      item
      lg={3}
      md={3}
      sm={3}
      {...getTestAutomationProps("footer-links-group")}
      id={`footer-links-group-${sectionId}`}
      aria-labelledby={titleId}
    >
      <Box>
        <Typography
          variant="body1"
          component="h2"
          className={GROUPED_LINKS_COLUMN_CLASSES.headline}
          id={titleId}
          {...getTestAutomationProps("title")}
        >
          {headline?.toUpperCase()}
        </Typography>
        <List sx={{ p: 0 }}>
          <ListItem sx={{ p: 0 }} />
          {links?.map((el, index) => (
            <LinkItem
              key={index}
              link={el?.link}
              target={shouldOpenAllLinksInNewTab ? "_blank" : undefined}
            />
          ))}
        </List>
        {showCountrySelector && (
          <Box mt={5}>
            <CountrySelector
              className={GROUPED_LINKS_COLUMN_CLASSES.countrySelector}
              value={selectedCountry}
              selectedLanguage={selectedLanguage}
              onChange={setSelectedCountry}
              countries={countries}
              title={title}
              description={description}
            />
          </Box>
        )}
      </Box>
    </GroupedLinksColumnContainer>
  );
};
